import { useEffect } from 'react';
import { useFieldSettings } from 'components/GenericWizard/wizards/field/';
import FieldSettingsBasic from '../FieldSettingsBasic';
import { EMPTY_OBJECT } from 'utility/fieldHelpers';

const ActivityFieldWizard = ({ onChange, data = EMPTY_OBJECT, errors }) => {
  const { formData, updateField, resetField, updateValidation, isComplete } =
    useFieldSettings(data);

  // Fires whenever local form state changes, with the onChange handler
  // allowing the parent to see and react to those changes
  useEffect(() => {
    onChange({ data: formData, isComplete });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData, isComplete]);

  // This is the initial step of your wizard
  // Subsequent steps will be defined within each step
  return (
    <FieldSettingsBasic
      updateField={updateField}
      resetField={resetField}
      updateValidation={updateValidation}
      formData={formData}
      data={data}
      errors={errors}
      isActivityField
    />
  );
};

export default ActivityFieldWizard;
